import i18next from "i18next";
import I18NextVue from "i18next-vue";
import LanguageDetector from "i18next-browser-languagedetector";
import resources from "virtual:i18next-loader";

// console.log("i18n",JSON.parse(JSON.stringify(resources)))

function formatResources(resources) {
  const result = {};
  for (const [lang, data] of Object.entries(resources)) {
    result[lang] = {translation: data};
  }

  return result;
}

i18next
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    missingWarn: false,
    // saveMissing: true,
    // missingKeyHandler: (lng, ns, key) => {
    //   console.log(`Missing key: ${key} in namespace ${ns} for language ${lng}`);
    //   let split = key.split(".");
    //   console.log(resources[lng][split[0]][split[1]], resources[lng][split[0]][split[1]][split[2]], resources[lng][split[0]][split[1]][split[2]]?.[split[3]], resources[lng][split[0]][split[1]][split[2]]?.[split[3]]?.[split[4]])
    // },
    fallbackWarn: false,
    resources: formatResources(resources),
    languages: {
      de: "Deutsch",
      en: "English"
    }
  });

export default function (app) {
  console.log("i18n function");
  app.use(I18NextVue, { i18next });
  return app;
}
